<style lang="stylus" scoped>
  @import '../../../stylesheet/variable.styl'
  ul, li
    list-style none
    padding 0
    margin 0
  p
    padding 0
    margin 0
  .limit-film-view
    margin-top 44px
    min-height calc(100vh - 44px)
    background #ffffff
    .film-sum
      height 39px
      padding 0 15px
      line-height 39px
      background rgb(244,244,244)
      font-size 15px
      color rgb(121,125,130)
    .film-list
      .film-item
        width 100%
        height 49px
        line-height 49px
        display flex
        position relative
        margin-left 15px
        box-sizing border-box
        font-size 15px
        color rgb(25,26,27)
        &::after
          setBottomLine(rgb(234,234,234))
    .no-film
      text-align center
      padding-top 40%
      img
        width 95px
        height 95px
      .no-text
        color rgb(189, 192, 197)
        font-size 14px
</style>
<template>
  <div class="limit-film-view">
    <my-header class="header"></my-header>
    <div v-if="filmList.length" class="film-sum">可观看{{filmList.length}}部影片</div>
    <div v-if="filmList.length">
      <ul class="film-list">
        <li v-for="film in filmList" :key="film.filmId" class="film-item" @click="toFilmDetail(film)">
            {{film.filmName}}
        </li>
      </ul>
    </div>
    <div class="no-film" v-else-if="finishGetCardFilm">
      <img :src="nofilmImg">
      <div class="no-text">暂无可适用影片</div>
    </div>
  </div>
</template>
<script>
  import myHeader from '../../components/header.vue'
  import op from 'object-path'
  import _ from 'underscore'
  import icon from '../../components/icon.vue'
  import moment from 'moment'
  import CONSTANT from "../../constant/card"

  export default {
      data() {
          return {
            isInPreorder: +this.$route.query.isInPreorder,
            finishGetCardFilm: false,
            nofilmImg: require('../../../image/card/nofilm.png')
          }
      },
      computed: {
        filmList() {
          const filmList = this.$store.state.card.limitFilm
          return filmList
        }
      },
      methods: {
        toFilmDetail(item) {
          if (this.isInPreorder) {
            return
          }
          this.$route.push({
            name: 'filmDetail',
            id: item.filmId
          })
        }
      },
      components: {
        'my-header': myHeader,
        icon,
      },
      mounted() {
          const vm = this
          const query = this.$route.query

          if (this.isApp) {
            document.title = '适用影片'
          }
          if (query && query.type) {
            const type = parseInt(query.type)
            const content = decodeURIComponent(query.content).replace(/\s/g, '+')
            this.$store.dispatch('getLimitFilm', {
              type,
              content,
            }).then(d => {
              this.finishGetCardFilm = true
            }).catch(e => this.finishGetCardFilm = true)
          }
      }
  }
</script>
